// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Qi6g","messages":"Chat_messages__2ziq9","dateDivider":"Chat_dateDivider__1eezI"};